module.exports = __webpack_public_path__ + "img/loading.c336831c.gif";